export default __webpack_public_path__ + "static/media/Humes 1.6 ratio.e88a0b7b.png";